const name = 'socket';

export const SOCKET_MANAGEMENT_INIT_CONNECT = `${name}/SOCKET_MANAGEMENT_INIT_CONNECT`;

export const SOCKET_CONNECTING = `${name}/SOCKET_CONNECTING`;
export const SOCKET_CONNECTED = `${name}/SOCKET_CONNECTED`;
export const SOCKET_DISCONNECTED = `${name}/SOCKET_DISCONNECTED`;

export default name;
